import { AddressSidebarItemResponse, AddressSidebarItemResponseList } from '@/types/service-response'

export class AddressSidebarItem {
  public constructor (
    readonly id: number,
    readonly name: string,
    readonly addressGroupId: number,
    readonly active: boolean,
    readonly isPrivateAddress: boolean
  ) {}

  static createFromResponse (responseData: AddressSidebarItemResponseList): Array<AddressSidebarItem> {
    let result: Array<AddressSidebarItem> = []
    if (responseData) {
      result = responseData.map((address: AddressSidebarItemResponse ) => {
        return new AddressSidebarItem(
          address.ID,
          address.Name,
          address.AdressGruppe,
          address.Active,
          address.PrivatAdresse
        )
      })
    }
    return result
  }
}
